export const getInitialState = (): any => ({
  previewStatusData: {}
});
